import { useQuery } from 'react-query';
import getBIF from 'data/requests/getBIF';
import type { BIFData } from 'data/types/BIF';

const useBIF = (org_id: string) => {
  const { data, isLoading, isFetching, refetch } = useQuery<BIFData>(
    ['bif', org_id],
    () => getBIF(org_id),
    {
      enabled: !!org_id,
    },
  );
  return { BIF: data, isLoading, isFetching, refetch };
};

export default useBIF;
